import {useContext} from 'react';
import {MicrosoftOAuthContext} from '../context';

/**
 * Custom hook to access the Microsoft OAuth context.
 *
 * This hook must be used within a MicrosoftOAuthProvider. If the context is not available,
 * it throws an error.
 *
 * @returns {object} The Microsoft OAuth context.
 * @throws {Error} If called outside of a MicrosoftOAuthProvider.
 */
export function useMicrosoftOAuth() {
	const context = useContext(MicrosoftOAuthContext);
	if (!context) {
		throw new Error(
			'Microsoft OAuth components must be used within MicrosoftOAuthProvider',
		);
	}
	return context;
}
